// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__5KUkT","fade-in":"Message_fade-in__yoP5f","inline":"Message_inline__OX0hB","error":"Message_error__zzu3q"};